// @flow
import dispatchAsync from 'utils/dispatchAsync';
import type { ZuzuThunk } from 'types';

export type User = {
  tmpUserId: string,
  realUserId: string,
  firstname: string,
  lastname: string,
  email: string,
  createdAt: number,
  spamStatus: string,
};

export type LoadAllUsersAction = {
  type: 'LOAD_ALL_USERS',
  payload?: Array<User>,
  meta: {
    done: boolean,
    error?: boolean,
  },
};

export const LOAD_ALL_USERS = 'LOAD_ALL_USERS';
export const loadAllUsers = (): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: LOAD_ALL_USERS,
    url: '/api/management/users/all',
    method: 'get',
    dispatch,
  });



// WEBPACK FOOTER //
// ./src/redux/actions/users.js